import JsPDF from 'jspdf'
import 'jspdf-autotable'
import { notificationError } from '../../../../utils/notification'
import { normalizeReportTableDataForExport } from './Functions'

export const exportToPDF = async (reportDefRef, reportTableColumns, rawReportTableData, outputOption = 'download') => {
  
  //Function constants
  const pointsPerInch = 72
  const lineHeightFactor = 1.15 //Add to pageLayout in db?  ? jspdf.lineHeightFactor - what is this used for

  let xOffset = 0
  let yOffset = 0
  let columnAlignment = []

  const getCurrentDateTime = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const year = now.getFullYear();
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format
  
    return `${month}/${day}/${year} ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
  }

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    const cleaned = ("" + phone).replace(/\D/g, ""); // Remove non-numeric characters
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
  };

  //Normalize report data for export.  Format dates, numbers, join arrays, strip markup codes, etc.
  const reportTableData = await normalizeReportTableDataForExport(rawReportTableData, reportDefRef.current)

  const fileName = reportDefRef.current.reportName ? reportDefRef.current.reportName : "Untitled_Report"
  const reportName = reportDefRef.current.reportName ? reportDefRef.current.reportName : "Untitled Report"
  const reportTitle = reportDefRef.current.reportTitle ? reportDefRef.current.reportTitle : ""
  const reportNotes = reportDefRef.current.reportNotes ? reportDefRef.current.reportNotes : ""

  const pageOrientation = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.pageOrientation : "Portrait";
  const pageFormat = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.pageFormat : "Letter";
  //Does jspdf handles page orientation by considering dimensions as "Short side" and "long side", not width/height?
  const pageHeight = pageOrientation === 'Portrait' ?  reportDefRef.current.pageLayout.pageHeight * pointsPerInch :  reportDefRef.current.pageLayout.pageWidth * pointsPerInch
  const pageWidth = pageOrientation === 'Portrait'  ?  reportDefRef.current.pageLayout.pageWidth * pointsPerInch :  reportDefRef.current.pageLayout.pageHeight * pointsPerInch
  const marginTop = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.marginTop * pointsPerInch : 0.5 * pointsPerInch; //Convert inches(db unit) to points(pdf unit)
  const marginBottom = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.marginBottom * pointsPerInch : 0.5 * pointsPerInch; //Convert inches(db unit) to points(pdf unit)
  const marginLeft = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.marginLeft * pointsPerInch : 0.5 * pointsPerInch; //Convert inches(db unit) to points(pdf unit)
  const marginRight = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.marginRight * pointsPerInch : 0.5 * pointsPerInch; //Convert inches(db unit) to points(pdf unit)
  const fontName = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.fontName : "Helvetica";
  const fontStyle = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.fontStyle : "Normal";
  const fontSize = reportDefRef.current.pageLayout ? reportDefRef.current.pageLayout.fontSize : 10
  const lineHeight = fontSize * lineHeightFactor;

  //Get list of fieldNames and titles from reportableColumns (use reportTableColumns because it has the current order of reportTableColumns) and set header names used by autotable.
  const fieldNames = reportTableColumns.map(column => column.dataIndex)
  //const headerNames = reportTableColumns.map(column => column.title.props.children) //before tooltipText added to headers
  const headerNames = reportTableColumns.map(column => column.title.props.children[1].props.children)

  const districtName = reportDefRef.current.district.name
  const districtAddress = reportDefRef.current.district.address
  const districtCityStateZip = reportDefRef.current.district.city + ', ' + reportDefRef.current.district.state + '  ' + reportDefRef.current.district.zip 
  const districtPhone = 'Phone: ' + formatPhoneNumber(reportDefRef.current.district.phone) + '     Fax:' + formatPhoneNumber(reportDefRef.current.district.fax)
  const districtWebsite = reportDefRef.current.district.website

  //Check pdf for potential errors like "header height exceeds page height" which happens when there's too much data to fit on a page 
  const validatePdfDef = async () => {

    //Temporary doc so we can use jspdf functions
    const tempDoc = JsPDF({
      orientation: pageOrientation,
      unit: 'pt',
      // format: pageFormat,
      format: [pageWidth, pageHeight],  
      lineHeight: 1,
      page: 1
    })

    //Get column header captions
    const headerCaptions = reportTableColumns.map(column => column.title.props.children[1].props.children)
    console.log('exportToPDF',headerCaptions,reportTableColumns)

    //Get average column width
    const tableWidth = pageWidth - marginLeft - marginRight;
    const columnCount = headerCaptions.length;
    const averageColumnWidth = columnCount > 0 ? tableWidth / columnCount : 1
  
    //Split the captions into multiple lines to fit within the column widths and find the max number of lines required
    const headerLineCounts = (headerCaptions ?? []).map((rawCaption) => {
      const caption = String(rawCaption ?? '').trim();  //stringify & trim to avoid runtime errors
      const lines = tempDoc.splitTextToSize(caption, averageColumnWidth); // split into lines for the given width
      return lines.length;          // always a number
    });

    // const headerLineCounts = headerCaptions.map((caption) => {
    //   const lines = tempDoc.splitTextToSize(caption, averageColumnWidth);
    //   return lines.length
    // })
    const maxHeaderLineCount =  headerLineCounts.length > 0 ? Math.max(...headerLineCounts) : 0;

    //Calc header row height(with 10% cushion) and check it against page height 
    const headerRowHeight = maxHeaderLineCount *  lineHeight * 1.10
    const usablePageHeight = (pageHeight - marginTop - marginBottom) 
    // console.log('check',usablePageHeight,headerRowHeight)
    // console.log('header line counts',headerLineCounts,'max:',maxHeaderLineCount,'header height',headerRowHeight,usablePageHeight)
    if (headerRowHeight > usablePageHeight ) {
      return false
    };
    return true
    // }
  }
  
  if (!await validatePdfDef()) {
    notificationError(<div>I can't fit all of this data on the page as it is defined.<br /><br />Try reducing font size, increasing page height, and/or removing columns from the report.</div>)
    return
  } 

  //Load an array using reportTableData (antd table extra.currentDataSource object).  reportData filtered and sorted in table.
  //currentDataSource includes __typedef column and does not guarantee proper column order (? not positive about column order).
  //Following removes __typedef property and puts column data in order as displayed in UI.
  let pdfTableData = []

  if (reportTableData !== undefined) {

    //table data
    for (const dataRow of reportTableData) {
      let newRow = []
      for (const field of fieldNames) {
        newRow.push(dataRow[field])
      }
     pdfTableData.push(newRow)
    }

    //Column alignment based on whether data is character or number (Just tests first row of data)
    const firstDataRow = reportTableData[0]
    if (firstDataRow !== undefined) {
      for (const field of fieldNames) {
        if (isNaN(firstDataRow[field])) {
          columnAlignment.push({halign: "left"})
        } else {
          columnAlignment.push({halign: "right"})
        }
      }
    }
  }

  //Create pdf doc and set margins (setting "pageFormat" sets page height/width).
  const doc = JsPDF({
    orientation: pageOrientation,
    unit: 'pt',
    // format: pageFormat,
    format: [pageWidth, pageHeight],  //These values get interpreted as "long side" and "short side" based on orientation.
    lineHeight: 1,
    page: 1
  })
  // console.log('width',doc.internal.pageSize.getWidth())
  // console.log('height',doc.internal.pageSize.getHeight())

  doc.margins = {
    top: marginTop,
    bottom: marginBottom,
    left: marginLeft,
    width: pageWidth
  } //Note width vs. right margin

  //Calculate yOffset for table based on existence of title and notes.
  //let tableStartY = marginTop + fontSize * 1.2 * (1 / lineHeightFactor) //Top margin and report name
  let tableStartY = marginTop //Top margin
  tableStartY += districtName ? fontSize * 1 * lineHeightFactor : 0 
  tableStartY += districtAddress ? fontSize * 0.8 * lineHeightFactor : 0 
  tableStartY += districtCityStateZip ? fontSize * 0.8 * lineHeightFactor : 0 
  tableStartY += districtPhone ? fontSize * 0.8 * lineHeightFactor : 0 
  tableStartY += districtWebsite ? fontSize * 0.8 * lineHeightFactor : 0 
  tableStartY += fontSize * lineHeightFactor  //Blank line after district info

  tableStartY += reportTitle ? fontSize * 1.2 * lineHeightFactor : 0 //reportTitle if it exists
  tableStartY += fontSize * lineHeightFactor  //Blank line after title

  const tableTopMargin = tableStartY + fontSize * lineHeightFactor //Starting y position on all pages other than first
  let reportNotesHeight = 0
  if (reportNotes) {
    const reportNotesSplit = doc.splitTextToSize(
      reportNotes,
      pageWidth - marginLeft - marginRight - 10,
      { fontSize: fontSize }
    ) //Handle long notes that span multiple lines
    reportNotesHeight = reportNotesSplit.length * (fontSize * lineHeightFactor)
    //tableStartY += reportNotesHeight + fontSize * lineHeightFactor + 24 //use this if we want the "Notes:" caption.  I don't like it.
    tableStartY += reportNotesHeight + fontSize * lineHeightFactor //height of reportNotes + box around notes padding and line width

  }
  tableStartY += fontSize * lineHeightFactor //blank line before table

  //reportTableData table
  doc.autoTable({
    head: [headerNames],
    body: pdfTableData,
    colunWidth: 'linebreak',
    orientation: pageOrientation,
    theme: 'plain', //striped, grid or plain
    // startY: 500,  //Need to fix this calc
    startY: tableStartY,
    margin: { top: tableStartY },  // applies to pages 2+

    showHead: 'everyPage',
    tableWidth: 'auto',

    headStyles: { 
      // cellPadding: { top: 3, right: 2, bottom: 3, left: 2 }, 
      cellPadding: 2,
      fillColor: [245, 245, 245], 
      textColor: [0, 0, 0],
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      halign: 'center',
      valign: 'middle',
      lineHeight: 1.0,
      overflow: 'linebreak',  //Looks better(more header text) but can blow up if header height > page height
    },

    bodyStyles: { 
      cellPadding: { top: 3, right: 3, bottom: 3, left: 3 },
      halign: 'center'
    }, //Effectively changes row heights

    styles: {
      minCellHeight: 9,
      halign: 'left',
      valign: 'bottom',
      overflow: 'linebreak',
      cellWidth: '100',
      cellPadding: {
          cellPadding: { top: 3, right: 3, bottom: 3, left: 3 }
      },
      oveflowColumns: 'linebreak',
      font: fontName,
      fontStyle: fontStyle,
      fontSize: fontSize
    },

    //didParseCell is read only.  
    // didParseCell: function (data) {
    //   console.log('in didParseCell',data)
    // },

    //willDrawCells fires immediately before a cell(row) is drawn.  Use it to vary the lineHeightFactor to get a better row height.
    willDrawCell: function (hookData) {
      // if (hookData.row.section === 'head') {
      //   const headerRows = hookData.row.height / fontSize
      //   switch (true) {
      //     case headerRows < 3:
      //       doc.setLineHeightFactor(1.15)
      //       break
      //     case headerRows >= 3 && headerRows < 5:
      //       doc.setLineHeightFactor(1.25)
      //       break
      //     case headerRows >= 5 && headerRows < 7:
      //       doc.setLineHeightFactor(1.5)
      //       break
      //     default:
      //       doc.setLineHeightFactor(1.15)
      //       break
      //   }
      // }
    },

    //Fires for every page
    didDrawPage: function (hookData) {
      //reportName and reportTitle.  Every page.
      doc.setFontSize(fontSize * 1.2) //font 20% larger
      doc.setFont(fontName, 'bold')
      yOffset = marginTop + fontSize * (1 / lineHeightFactor) //topMargin + row height(font size) w/o lineHeightFactor
      xOffset = doc.internal.pageSize.getWidth() / 2
      // doc.text(reportName, xOffset, yOffset, { align: 'center' })  //Moved reportName to footer
      // yOffset += fontSize * 1.2 * lineHeightFactor
      if (districtName) {
        doc.setFontSize(fontSize * 1.2) //font 10% larger
        doc.setFont(fontName, 'bold')
        doc.text(districtName, xOffset, yOffset, { align: 'center' })
        yOffset += fontSize * 1 * lineHeightFactor
      }
      if (districtAddress) {
        doc.setFontSize(fontSize * 0.8) //font 10% larger
        doc.setFont(fontName, 'bold')
        doc.text(districtAddress, xOffset, yOffset, { align: 'center' })
        yOffset += fontSize * 0.8 * lineHeightFactor
      }
      if (districtCityStateZip) {
        doc.setFontSize(fontSize * 0.8) //font 10% larger
        doc.setFont(fontName, 'bold')
        doc.text(districtCityStateZip, xOffset, yOffset, { align: 'center' })
        yOffset += fontSize * 0.8 * lineHeightFactor
      }
      if (districtPhone) {
        doc.setFontSize(fontSize * 0.8) //font 10% larger
        doc.setFont(fontName, 'bold')
        doc.text(districtPhone, xOffset, yOffset, { align: 'center' })
        yOffset += fontSize * 0.8 * lineHeightFactor
      }
      if (districtWebsite) {
        doc.setFontSize(fontSize * 0.8) //font 10% larger
        doc.setFont(fontName, 'bold')
        doc.text(districtWebsite, xOffset, yOffset, { align: 'center' })
        yOffset += fontSize * 0.8 * lineHeightFactor
      }
      yOffset += fontSize * 1 * lineHeightFactor  //Blank line after district info

      if (reportTitle) {
        doc.setFillColor(245, 245, 245); // RGB for gray
        doc.rect(
          marginLeft, 
          yOffset - 5, 
          doc.internal.pageSize.getWidth() - marginLeft - marginRight, 
          fontSize * 1.2 * lineHeightFactor + 5,
          "F"
        ); // Draw filled rectangle

        doc.setLineWidth(0.5)

        doc.line(
          marginLeft, 
          yOffset - 5,
          doc.internal.pageSize.getWidth() - marginLeft,
          yOffset - 5,
        ); // Top line

        doc.line(
          marginLeft, 
          yOffset + 1 + (fontSize * 1.2 * lineHeightFactor),
          doc.internal.pageSize.getWidth() - marginLeft,
          yOffset + 1 + (fontSize * 1.2 * lineHeightFactor),
        ); // Bottom line

        yOffset += fontSize //little space between district info and report title
        doc.setFontSize(fontSize * 1.2) //font 10% larger
        doc.setFont(fontName, 'bold')
        //doc.text(reportTitle, marginLeft + 3, yOffset, { align: 'center' })
        doc.text(reportTitle, xOffset, yOffset, { align: 'center' })
        yOffset += fontSize * 1.2 * lineHeightFactor
      }

      //reportNotes on first page only.  This could be adjusted slightly to better handle fitting based on number of rows required (e.g. change rect height)
      if (reportNotes && hookData.pageNumber === 1) {
        doc.setFontSize(fontSize)
        doc.setFont(fontName, 'normal')
        // yOffset += fontSize * lineHeightFactor
        // doc.text('Notes:', marginLeft, yOffset)
        // yOffset += 5
        doc.setLineWidth(0.5)
        doc.rect( //Draw box around notes?  x/y/width/height
          marginLeft + 1,
          yOffset,
          doc.internal.pageSize.getWidth() - marginLeft - marginRight - 2,
          reportNotesHeight + 5
        )
        yOffset += 12
        doc.text(reportNotes, marginLeft + 5, yOffset, {
          maxWidth: pageWidth - marginLeft - marginRight - 10,
          lineHeightFactor: 1.15
        }) //Internal padding of 5? style for linebreak
      }
      //tableStartY = 50




      //Footer, all pages.
      const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
      const totalPages = doc.internal.getNumberOfPages();

      doc.setFontSize(fontSize * 0.8)
      doc.setFont(fontName, 'normal')

      doc.text(
        "Tames Assist " + reportName,
        marginLeft,
        doc.internal.pageSize.getHeight() - (fontSize * lineHeightFactor) - marginBottom + 15
      )

      const pageCount = doc.internal.getNumberOfPages()
      const pageString = 'Page ' + String(hookData.pageNumber) + ' of ' + String(doc.getNumberOfPages())
      doc.text(
          // `Page ${currentPage} of ${totalPages}`,
          `Page ${currentPage}`,
          doc.internal.pageSize.getWidth() / 2,
          doc.internal.pageSize.getHeight() - (fontSize * lineHeightFactor) - marginBottom + 15
      )

      const dateTime = getCurrentDateTime();
      doc.text(
        dateTime,
        doc.internal.pageSize.getWidth() - marginRight - doc.getTextWidth(dateTime),
        doc.internal.pageSize.getHeight() - (fontSize * lineHeightFactor) - marginBottom +15    
      )
    }
  })

  //Saves to user's download path (e.g. c:\users\user name\Downloads) and prompts in browser
  if (outputOption === 'download') {
    doc.save(`${fileName}.pdf`)
  }

  //Opens the pdf in a new browser tab
  if (outputOption === 'open') {
    const pdfBlob = new Blob([doc.output()], { type: 'application/pdf' })
    const blobUrl = URL.createObjectURL(pdfBlob)
    window.open(blobUrl) // will open a new tab
  }

  //Returns blob
  //Creating a Blob/Buffer differs slightly between client web api and backend node.js
  //There are outputOptions of 'blob' and 'apiblob' so that we can use the same code both frontend and backend
  if (outputOption === 'blob') {  //Call by client
    const pdfBlob = new Blob([doc.output('blob')], {
    type: 'application/pdf'
    })
    return await pdfBlob.text() //utf-8 text of pdf content
  }
  if (outputOption === 'apiblob') { //Call by api
    const buffer = Buffer.from(doc, 'utf-8'); //Need to test this from reportRunner code to see if it generates pdf
    return buffer.toString(); // returns PDF text
  }
}
